var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep0(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 344,
    viewBox: "0 0 218 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 87,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 143,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 200,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 255,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 313,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 44,
    x2: 33,
    y2: 68,
    stroke: "#B5BECC",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 100,
    x2: 33,
    y2: 124,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 156,
    x2: 33,
    y2: 180,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 212,
    x2: 33,
    y2: 236,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 268,
    x2: 33,
    y2: 292,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#EFB741"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.91 20.98H33.294C32.9602 20.6098 32.4852 20.3984 31.9868 20.3984C31.4883 20.3984 31.0133 20.6098 30.6795 20.98H29.0635C28.8702 20.9808 28.6899 21.077 28.5814 21.2369C28.4729 21.3969 28.4504 21.6001 28.5211 21.78L29.0635 23.3176H34.9098L35.4522 21.78C35.523 21.6001 35.5004 21.3969 35.3919 21.2369C35.2835 21.077 35.1031 20.9808 34.9098 20.98H34.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0929 24.4922H34.9391C34.9391 24.4922 39.0317 27.9993 39.0317 32.0922C39.0317 34.4297 37.2765 35.5993 36.1086 35.5993H27.9231C26.7601 35.5993 25 34.4298 25 32.0922C25 27.9993 29.0929 24.4922 29.0929 24.4922ZM31.7838 32.9643C31.8153 32.9881 31.8581 33 31.9122 33H32.3243C32.3649 33 32.3986 32.9905 32.4257 32.9714C32.4527 32.9524 32.4662 32.9238 32.4662 32.8857C32.4662 32.8524 32.4482 32.8167 32.4122 32.7786L30.911 30.9561C31.252 30.9433 31.5317 30.8746 31.75 30.75C31.9797 30.6167 32.1464 30.4405 32.25 30.2214C32.3361 30.0469 32.3879 29.8588 32.4055 29.6571H32.8446C32.8896 29.6571 32.9257 29.6429 32.9527 29.6143C32.9842 29.5857 33 29.5452 33 29.4929V29.3143C33 29.2619 32.9842 29.2214 32.9527 29.1929C32.9257 29.1643 32.8896 29.15 32.8446 29.15H32.3811C32.3544 29.0085 32.3108 28.8776 32.25 28.7571C32.2024 28.6628 32.1369 28.5819 32.0535 28.5143H32.8446C32.8896 28.5143 32.9257 28.5 32.9527 28.4714C32.9842 28.4381 33 28.3976 33 28.35V28.1643C33 28.1167 32.9842 28.0786 32.9527 28.05C32.9257 28.0167 32.8896 28 32.8446 28H30.1554C30.1104 28 30.0721 28.0167 30.0405 28.05C30.0135 28.0786 30 28.1167 30 28.1643V28.35C30 28.3976 30.0135 28.4381 30.0405 28.4714C30.0721 28.5 30.1104 28.5143 30.1554 28.5143H30.6486C30.9369 28.5143 31.1599 28.5571 31.3176 28.6429C31.4752 28.7286 31.5833 28.8452 31.6419 28.9929C31.6641 29.0432 31.6824 29.0956 31.6968 29.15H30.1554C30.1104 29.15 30.0721 29.1643 30.0405 29.1929C30.0135 29.2214 30 29.2619 30 29.3143V29.4929C30 29.5452 30.0135 29.5857 30.0405 29.6143C30.0676 29.6429 30.1059 29.6571 30.1554 29.6571H31.7251C31.7108 29.7687 31.6831 29.871 31.6419 29.9643C31.5833 30.1071 31.4707 30.2214 31.3041 30.3071C31.1374 30.3929 30.8964 30.4357 30.5811 30.4357H30.2162C30.1712 30.4357 30.1329 30.4524 30.1014 30.4857C30.0743 30.5143 30.0608 30.5524 30.0608 30.6V30.7571C30.0608 30.8238 30.0653 30.8738 30.0743 30.9071C30.0878 30.9357 30.1126 30.969 30.1486 31.0071L31.6959 32.8786C31.723 32.9119 31.7523 32.9405 31.7838 32.9643Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 84,
    r: 16,
    fill: "#51668A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.4913 79.0128C39.4524 78.8447 39.3295 78.7086 39.1663 78.6527L37.8014 78.1977L37.3463 76.8327C37.3102 76.7192 37.2347 76.6224 37.1335 76.5596C37.0324 76.4968 36.9121 76.4721 36.7943 76.4901C36.6766 76.5082 36.5691 76.5676 36.4913 76.6577L34.6363 78.5128C34.5729 78.5774 34.5283 78.6581 34.5072 78.7461C34.486 78.8342 34.4892 78.9264 34.5163 79.0128L34.9514 80.3178L34.3613 80.9377C34.6159 81.1524 34.8517 81.3882 35.0664 81.6428L35.6613 81.0528L36.9914 81.5128C37.0433 81.5287 37.097 81.5372 37.1514 81.5378C37.2825 81.5372 37.4082 81.4851 37.5014 81.3928L39.3464 79.5128C39.4141 79.4508 39.4635 79.3714 39.489 79.2831C39.5147 79.1949 39.5155 79.1014 39.4914 79.0128L39.4913 79.0128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4918 85.514C33.4924 86.4173 33.0862 87.2728 32.3859 87.843C31.6854 88.4132 30.7653 88.6375 29.8809 88.4537C28.9967 88.2697 28.2423 87.6972 27.8273 86.895C27.4122 86.0928 27.3807 85.1463 27.7414 84.3183C28.1021 83.4903 28.8168 82.8687 29.6869 82.6264C30.5569 82.3841 31.49 82.5466 32.2268 83.069L34.3619 80.939H34.3617C33.1799 79.9391 31.6573 79.4347 30.1123 79.5312C28.5672 79.6276 27.1192 80.3177 26.0709 81.4569C25.0227 82.5962 24.4554 84.0965 24.4876 85.6443C24.5198 87.1921 25.149 88.6674 26.2437 89.762C27.3383 90.8566 28.8137 91.4859 30.3614 91.518C31.9091 91.5503 33.4094 90.983 34.5488 89.9348C35.688 88.8866 36.378 87.4386 36.4745 85.8934C36.571 84.3483 36.0665 82.8256 35.0667 81.6439L32.9366 83.779V83.7789C33.297 84.2858 33.491 84.892 33.4917 85.5139L33.4918 85.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8466 85.8666C30.7527 85.9613 30.625 86.0145 30.4916 86.0145C30.3582 86.0145 30.2304 85.9613 30.1365 85.8666C30.0419 85.7728 29.9887 85.645 29.9887 85.5116C29.9887 85.3782 30.0419 85.2504 30.1365 85.1566L31.4916 83.7966C30.9206 83.4597 30.2209 83.4236 29.6184 83.7C29.0157 83.9763 28.5866 84.5302 28.4694 85.1827C28.3523 85.8353 28.5619 86.5038 29.0307 86.9725C29.4994 87.4413 30.1679 87.6509 30.8205 87.5338C31.473 87.4166 32.0269 86.9875 32.3032 86.3848C32.5796 85.7823 32.5435 85.0826 32.2066 84.5116L30.8466 85.8666Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 196,
    r: 16,
    fill: "#0B2653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.2926 190.844C36.2821 190.705 34.3459 189.873 32.9309 188.555L32.5584 188.208C32.4096 188.069 32.2234 188 32 188C31.7767 188 31.5904 188.069 31.4416 188.208L31.0692 188.555C29.6171 189.907 27.7183 190.705 25.7075 190.844C25.2979 190.878 25 191.191 25 191.572V193.653C25 198.022 27.5317 202.079 31.6276 204.229C31.7392 204.299 31.8883 204.333 32 204.333C32.1488 204.333 32.2608 204.299 32.3724 204.229C36.4683 202.079 39 198.022 39 193.653V191.572C39 191.191 38.7021 190.879 38.2925 190.844H38.2926ZM31.9629 191.711C32.5959 191.711 33.1171 192.196 33.08 192.82L32.8566 196.878C32.8195 197.329 32.4471 197.675 31.963 197.675C31.4789 197.675 31.1067 197.328 31.0693 196.878L30.8459 192.82C30.8459 192.196 31.33 191.711 31.963 191.711H31.9629ZM31.9629 200.657C31.2929 200.657 30.7713 200.172 30.7713 199.548C30.7713 198.923 31.2926 198.438 31.9629 198.438C32.633 198.438 33.1545 198.923 33.1545 199.548C33.1543 200.172 32.633 200.657 31.9629 200.657Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 140,
    r: 16,
    fill: "#D17837"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9672 138.064H23.9777C23.6912 138.064 23.457 138.299 23.457 138.585V144.539C23.457 144.826 23.6912 145.06 23.9777 145.06H26.9672C27.2538 145.06 27.4879 144.826 27.4879 144.539V138.588C27.4879 138.299 27.2566 138.065 26.9672 138.065V138.064ZM26.0442 144.327C25.7301 144.327 25.4739 144.071 25.4739 143.757C25.4739 143.443 25.7301 143.187 26.0442 143.187C26.3582 143.187 26.6144 143.443 26.6144 143.757C26.6146 144.071 26.3583 144.327 26.0442 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5286 140.914C40.3494 140.801 40.1263 140.787 39.9362 140.881L36.5886 142.426C36.3737 142.71 36.0348 142.892 35.6518 142.892H32.7478C32.5962 142.892 32.4723 142.768 32.4723 142.616C32.4723 142.465 32.5962 142.341 32.7478 142.341H35.6518C35.8749 142.341 36.0733 142.222 36.1835 142.046C36.2111 142.005 36.2303 141.958 36.247 141.911C36.2524 141.897 36.2552 141.886 36.258 141.873C36.2718 141.82 36.2801 141.768 36.2801 141.713C36.2801 141.366 35.9963 141.082 35.6491 141.082H33.5744C33.5055 141.082 33.4394 141.057 33.3899 141.01C32.4778 140.186 31.3316 139.679 30.3288 139.655C29.403 139.633 28.5599 139.638 28.0392 139.644L28.0391 143.749C29.3754 144.518 32.004 145.895 33.0538 145.832C35.2773 145.705 40.4242 142.016 40.4738 141.978C40.4821 141.972 40.4903 141.967 40.4986 141.961C40.6914 141.854 40.8099 141.65 40.8099 141.429C40.8154 141.22 40.7107 141.03 40.5289 140.914L40.5286 140.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 133.568C37.6 134.158 36.3465 134.636 34.8 134.636C33.2536 134.636 32 134.158 32 133.568C32 132.978 33.2536 132.5 34.8 132.5C36.3464 132.5 37.6 132.978 37.6 133.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 139.46C36.4027 139.46 37.6001 138.896 37.6001 138.392L37.6 137.671C37.0163 138.102 36.0019 138.376 34.8 138.376C33.5981 138.376 32.5837 138.102 32 137.671V138.392C32.0001 138.896 33.1975 139.46 34.8002 139.46H34.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 137.852C36.4027 137.852 37.6001 137.288 37.6001 136.783L37.6 136.062C37.0163 136.493 36.0019 136.767 34.8 136.767C33.5981 136.767 32.5837 136.493 32 136.062V136.783C32.0001 137.288 33.1975 137.852 34.8002 137.852H34.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 136.244C36.4027 136.244 37.6001 135.68 37.6001 135.176L37.6 134.455C37.0163 134.886 36.0019 135.16 34.8 135.16C33.5981 135.16 32.5837 134.886 32 134.455V135.176C32.0001 135.68 33.1975 136.244 34.8002 136.244H34.8001Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 252,
    r: 16,
    fill: "#4081BD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5559 249.937C38.1502 248.606 37.3455 247.466 36.2268 246.633L32.5996 251.755L38.4679 253.98C38.9316 252.664 38.9621 251.268 38.556 249.937L38.5559 249.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4826 252.112L31.4653 252.097C31.4486 252.078 31.4366 252.057 31.4295 252.034C31.4146 251.986 31.4232 251.932 31.4531 251.889L35.2042 246.592C35.0212 246.47 34.8306 246.355 34.6354 246.251C33.6929 245.75 32.6391 245.484 31.5877 245.484C30.9487 245.484 30.3109 245.58 29.6921 245.769C28.0314 246.276 26.6676 247.399 25.8516 248.931C25.0357 250.464 24.8654 252.222 25.3719 253.883C25.8786 255.544 27.0017 256.907 28.5342 257.724C29.475 258.225 30.5281 258.489 31.5804 258.489C32.2224 258.489 32.8638 258.393 33.4861 258.203C35.3611 257.631 36.8561 256.264 37.5998 254.444L31.511 252.133C31.4973 252.126 31.488 252.118 31.4824 252.113L31.4826 252.112Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_202_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 308,
    r: 16,
    fill: "#A85CD7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 303.162H35.8001V301.296C35.8001 300.929 35.5001 300.629 35.1335 300.629H28.6001C28.2334 300.629 27.9334 300.929 27.9334 301.296V303.162H25C24.4334 303.162 24 303.629 24 304.162V306.729H40V304.162C40 303.629 39.5666 303.162 39 303.162H39.0001ZM29.2667 301.962H34.4667V303.162H29.2667V301.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 309.059H36.1V307.859H27.9V309.059H26.2V307.859H24V314.359C24 314.893 24.4334 315.359 25 315.359H39C39.5667 315.359 40 314.893 40 314.359V307.859H37.8V309.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_647",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_202_647",
    x: 0,
    y: 56,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_202_647",
    x: 0,
    y: 168,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_202_647",
    x: 0,
    y: 112,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_202_647",
    x: 0,
    y: 224,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_202_647",
    x: 0,
    y: 280,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_647",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep0);
export default __webpack_public_path__ + "static/media/step_0.e52c949b836c6f2d5aec11b91305d4b7.svg";
export { ForwardRef as ReactComponent };